import React from "react";
import { useCountdown } from "./Hooks";
import {
  CountdownWrapper,
  CountdownLabel,
  CountdownBoxes,
  CountdownBox,
  CountdownNum,
  CountdownUnit,
} from "../Styles";
import useWebinar from "../../../../hooks/useWebinar";

function CountdownStrip() {
  const { config } = useWebinar();
  const target = new Date(config?.hero?.countdownTarget).getTime();
  const cd = useCountdown(target);

  const boxes = [
    { num: cd.days, label: "Days" },
    { num: cd.hours, label: "Hours" },
    { num: cd.mins, label: "Mins" },
    { num: cd.secs, label: "Secs" },
  ];

  return (
    <CountdownWrapper>
      <CountdownLabel>Webinar starts in</CountdownLabel>
      <CountdownBoxes>
        {boxes.map((b) => (
          <CountdownBox key={b.label}>
            <CountdownNum>{b.num}</CountdownNum>
            <CountdownUnit>{b.label}</CountdownUnit>
          </CountdownBox>
        ))}
      </CountdownBoxes>
    </CountdownWrapper>
  );
}

export { CountdownStrip };
